// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toasted from 'vue-toasted'
import store from './store'
import VueMq from 'vue-mq'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Toasted)
Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm'
})
Vue.use(VueClipboard)

Vue.prototype.$appVersion = '2.14.8' // 現バージョン
Vue.prototype.$dbVersion = 27 // 更新があるときに上げる (追加のみの場合はそのまま)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js